import React from "react";
import PropTypes from "prop-types";
import _, { xor } from "lodash";
import { buildButtonStylesheet } from "./ElementButtonStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementButton = (props) => {
  let element = props.element;
  let options = element.options;
  const classes = style.classes(element, props.device);
  const stylesheet = buildButtonStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );

  return (
    <React.Fragment>
      <div
        id={"element" + element.id + "-content"}
        className={classes}
        data-element-id={element.id}
        data-font={element.options["button-font"]}
        dangerouslySetInnerHTML={{
          __html:
            props.builder == true
              ? "<div class='froala-editor'>" + element.html + "</div>"
              : element.html,
        }}
        role="button"
        tabIndex="0"
        aria-label={element.html}
      ></div>
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:button`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

const style = {
  classes: (element, device) => {
    let options = element.options;
    let classes = "element-content cf-button cf-button-primary cf-text-element cf-merge-tag-allowed";

    let buttonWidthClass = "cf-full-width";
    if (options["button-width"] && options["button-width"] !== "custom") {
      buttonWidthClass = options["button-width"];
    } else if (options["button-width"] == "custom") {
      buttonWidthClass = "";
    }

    if (device == "mobile") {
      if (options["button-width-mobile"] && options["button-width-mobile"] !== "custom") {
        buttonWidthClass = options["button-width-mobile"];
      } else if (options["button-width-mobile"] == "custom") {
        buttonWidthClass = "";
      }
    }
    classes += " " + buttonWidthClass;

    classes +=
      " " + (options["button-alignment"] ? options["button-alignment"] : "");

    classes +=
      " " +
      (options["button-size"] ? options["button-size"] : "cf-button-small");

    return classes;
  },
};

export default ElementButton;
